// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__nsiUI","col":"Table_col__VadSZ","fulfillmentStatus":"Table_fulfillmentStatus__22A_D","emailCol":"Table_emailCol__1O8Lu"};